import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CopyHighlightService {
  private readonly _highlightedIds = signal<Set<string>>(new Set());
  private _clearTimer?: ReturnType<typeof setTimeout>;

  public highlight(inputIds: string[], durationMs = 3000): void {
    clearTimeout(this._clearTimer);
    this._highlightedIds.set(new Set(inputIds));
    this._clearTimer = setTimeout(
      () => this._highlightedIds.set(new Set()),
      durationMs
    );
  }

  public isHighlighted(id: string): boolean {
    return this._highlightedIds().has(id);
  }
}
